<template>
  <Timeline
    :title="$t('nav.dms')"
    :timeline="timeline"
    :timeline-name="'dms'"
  />
</template>

<script src="./dm_timeline.js"></script>